import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import { EventManager } from '../vue/EventManager.js';

import ImageSlider from '../vue/ImageSlider.vue';
import PrimaryMenu from '../vue/PrimaryMenu.vue';
import LazyBackgroundImage from '../vue/LazyBackgroundImage.vue';
import LazyImage from '../vue/LazyImage.vue';
import ImageGallery from '../vue/ImageGallery.vue';
import TextInput from '../vue/TextInput.vue';
import PeoplePicker from '../vue/PeoplePicker.vue';
import PersonDetail from '../vue/PersonDetail.vue';
import TabbedContent from '../vue/TabbedContent.vue';
import HomeSlider from '../vue/HomeSlider.vue';
import MobileMenu from '../vue/MobileMenu.vue';

export default {
  init() {


    /* Exclusions

     Some plugins cause conflicts with Vue because they place inline <script> tags within the #app
     container. To work around this, I'm detaching anything with the class .vue-disable first,
     then re-attaching it at the bottom of this script once Vue has been instantiated.
    ---------------------------------------------------------------------------------------------------- */

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }


    /* Vue
    ---------------------------------------------------------------------------------------------------- */

    Vue.config.productionTip = false;

    Vue.use(VueLazyload);

    new Vue({
      data: {
        topScrollThreshold: 50,
        isScrolled: false,
        isShowingMenu: false,
        isShowingSubscribeForm: false,
        isPageReady: false,
      },

      components: {
        ImageSlider,
        HomeSlider,
        LazyBackgroundImage,
        LazyImage,
        PrimaryMenu,
        ImageGallery,
        TextInput,
        PeoplePicker,
        PersonDetail,
        TabbedContent,
        MobileMenu,
      },

      watch: {
        isShowingSubscribeForm: function (newValue, oldValue) {

          this.isShowingMenu = false;

          // lock scrolling while form is showing
          document.body.style.overflow = newValue == true ? 'hidden' : 'auto';

          // TL: Because Gravity Forms includes embedded <script> elements which
          //     conflicts with Vue, the markup is placed OUTSIDE the #app element.
          //     Therefore, I'm doing some old school class swapping to show the
          //     modal whenever isShowingSubscribeForm is true, rather than the
          //     usual <transition> component method.

          var modalEl = document.getElementById('subscribe-form-modal');
          modalEl.classList.toggle('open');

          if(newValue) {
            document.addEventListener('click', this.checkIfShouldCloseModal, false);
          } else {
            document.removeEventListener('click', this.checkIfShouldCloseModal, false);
          }
        },
      },

      methods: {
        checkIfShouldCloseModal (e) {
            if (!e.target.matches('.close-subscribe-form-modal')) return;
            e.preventDefault();
            this.toggleSubscribeForm();
        },
        scrollToElement (targetId, updateUrlOnComplete = false) {

          var self = this,
              headerHeight = 0; //document.getElementById('header').offsetHeight;

         self.scrollTo(targetId, 500, -headerHeight, () => {
           if(updateUrlOnComplete) {
             window.location.href = targetId;
           }
         });

        },
        scrollTo: function (to, duration = 500, offset = 0, onComplete = null) {

            this.isShowingMenu = false;

            /*

          Credit: https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5

          Example:
           * window.scrollPageTo('#some-section', 2000);
           * window.scrollPageTo(document.getElementById('some-section'), 1000);
           * window.scrollPageTo(500); // will scroll to 500px in 500ms
         */

            //t = current time
            //b = start value
            //c = change in value
            //d = duration
            const easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return (c / 2) * t * t + b;
                t--;
                return (-c / 2) * (t * (t - 2) - 1) + b;
            };

            return new Promise((resolve, reject) => {
                const element = document.scrollingElement;
                const self = this;

                if (typeof to === 'string') {
                    to = document.querySelector(to) || reject();
                }
                if (typeof to !== 'number') {
                    to = to.getBoundingClientRect().top + element.scrollTop;
                }

                to += offset;

                let start = element.scrollTop,
                    change = to - start,
                    currentTime = 0,
                    increment = 20;

                const animateScroll = function () {
                    currentTime += increment;
                    let val = easeInOutQuad(
                        currentTime,
                        start,
                        change,
                        duration
                    );
                    element.scrollTop = val;
                    if (currentTime < duration) {
                        setTimeout(animateScroll, increment);
                    } else {
                        resolve();

                        if(onComplete) {
                          onComplete();
                        }
                    }
                };
                animateScroll();
            });
        },
        isTouchDevice () {
          try {
            document.createEvent('TouchEvent');
            return true;
          } catch (e) {
            return false;
          }
        },
        didScroll () {
          this.isScrolled = (window.scrollY > this.topScrollThreshold);
          EventManager.$emit('did-scroll-window', window.scrollY);
        },
        toggleSubscribeForm () {
          this.isShowingSubscribeForm = !this.isShowingSubscribeForm;
        },
        toggleMenu () {
          this.isShowingMenu = !this.isShowingMenu;
        },
        onGoToUrl: function(url) {

          var self = this;
          self.isShowingMenu = false;

          setTimeout(function() {
            window.location.href = url;
          }, 500);

        },
        didLeaveMenu: function(url) {
          //this.isShowingMenu = false;
        },
      },

      created () {
        window.addEventListener('pageshow', this.didShowPage);
        window.addEventListener('scroll', this.didScroll);
        window.addEventListener('resize', this.didScroll);
      },

      mounted () {
        var self = this;

        EventManager.$on('should-go-to-url', self.onGoToUrl);

        setTimeout(function() {
          self.isPageReady = true;
        }, 500);

      },

      destroyed () {
        window.removeEventListener('pageshow', this.didShowPage);
        window.removeEventListener('scroll', this.didScroll);
        window.removeEventListener('resize', this.didScroll);
      },

    }).$mount('#app');


    /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

    for (var ii = 0; ii < matchingElements.length; ii++) {
        matchingElements[ii].innerHTML = hiddenMarkup[ii];
    }


  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js